import { isPlatformBrowser, NgFor, NgIf, NgOptimizedImage } from '@angular/common';
import {
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
  ViewEncapsulation
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  Meta, Title
} from '@angular/platform-browser';
import { Router, RouterLink } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import {
  AppComponent
} from 'src/app/app.component';
import {
  CommonComponent
} from 'src/app/common/common/common.component';
import { PopupAtecoComponent } from 'src/app/common/components/popup-ateco/popup-ateco.component';
import {
  AuthenticationService
} from 'src/app/services/authentication.service';
import {
  ConsoleLoggerService
} from 'src/app/services/console-logger.service';
import {
  Agent,
  AgentService,
  Article,
  ArticleService,
  Listing,
  ListingService,
  Professionist,
  ProfessionistService
} from '../../api';
import { CardAgenteComponent } from '../../common/components/card-agente/card-agente.component';
import { CardProfessionistaComponent } from '../../common/components/card-professionista/card-professionista.component';
import { CarouselAnnunciRecentiComponent } from '../../common/components/carousel-annunci-recenti/carousel-annunci-recenti.component';
import { FooterComponent } from '../../common/components/footer/footer.component';
import { HeaderComponent } from '../../common/components/header/header.component';
import { LoadingComponent } from '../../common/components/loading/loading.component';
import { MobileMenuComponent } from '../../common/components/mobile-menu/mobile-menu.component';
import { NewsCardComponent } from '../../common/components/news-card/news-card.component';
import { PopupComponent } from '../../common/components/popup/popup.component';
import { SearchBarAtecoComponent } from '../../common/components/search-bar-ateco/search-bar-ateco.component';
import { SearchBarInputComponent } from '../../common/components/search-bar-input/search-bar-input.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: true,
  imports: [HeaderComponent, SearchBarInputComponent, NgIf, CarouselAnnunciRecentiComponent, FormsModule, LoadingComponent, NgFor, CardAgenteComponent, CardProfessionistaComponent, NewsCardComponent, RouterLink, PopupComponent, FooterComponent, MobileMenuComponent, SearchBarAtecoComponent, PopupAtecoComponent, NgOptimizedImage],
  encapsulation: ViewEncapsulation.None
})
export class HomeComponent extends CommonComponent implements OnInit {
  agentArray: Agent[];
  professionistArray: Professionist[];
  latestArticlesArray: Article[];
  orderAgent = '';
  visitedListing: Listing[];

  isMobile: boolean;
  showLocalVisited = false;
  modalIsOpen: boolean;
  formValue: string;
  agentLoading: boolean;
  professionistLoading: boolean;
  isAgentSelected = true;

  constructor(private authenticationService: AuthenticationService, private titleService: Title, private metaTagService: Meta, public main: AppComponent, private agent: AgentService, private professionistAPI: ProfessionistService, private articleAPI: ArticleService, private router: Router, @Inject(PLATFORM_ID) private platformId: object, private listings: ListingService, private console: ConsoleLoggerService) {
    super(authenticationService);
  }

  async ngOnInit(): Promise<void> {
    console.log('LOG FROM HOME')
    if (isPlatformBrowser(this.platformId)) {
      window.innerWidth > 550 ? this.isMobile = false : this.isMobile = true;
    }
    this.titleService.setTitle('Case in vendita, annunci immobiliare in vendita - cercacasa.it');
    this.metaTagService.addTags([{
      name: 'keywords',
      content: 'Immobiliare, Cercacasa',
    }, {
      name: 'robots',
      content: 'index, follow',
    }, {
      name: 'author',
      content: 'Loud SRL',
    }, {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1',
    }, {
      name: 'date',
      content: '2020-11-09',
      scheme: 'YYYY-MM-DD',
    }, { charset: 'UTF-8' }]);

    if (this.isAgentSelected) {
      await this.getAgentData();
      await this.main.getFavouriteAgent();
    }
    else {
      await this.getProfessionistData();
      await this.main.getFavouriteProfessionists();
    }

    if (this.isLogged) {
      await this.main.getVisitedListings();
      this.visitedListing = this.main.visitedListings?.slice().reverse();
    } else {
      this.main?.getVisitedListing().then(data => {
        lastValueFrom(this.listings.listingGetVisitedListing(JSON.stringify(data))).then(results => {
          this.visitedListing = [];
          data.forEach((id: string) => {
            this.visitedListing.push(results.filter(a => a.id === id)[0]);
          });
        }).catch(e => this.console.log(e));
      }).catch(e => this.console.log(e));
    }

    if (this.showNews) {
      await this.getNewsData();
    }
  }

  async getProfessionistData(): Promise<void> {
    this.professionistArray = [];
    this.professionistLoading = true;
    try {
      // const filter = JSON.stringify({
      //   limit: 12,
      //   order: ['average_stars DESC', 'number_reviews DESC'],
      //   include: 'agency',
      // });
      // this.agentArray = await lastValueFrom( this.agent.agentFind(filter));
      const obj = this.main.getInfoFromlastSearch();
      this.professionistArray = await lastValueFrom(this.professionistAPI.professionistSearchBest(8, obj.regione, obj.provincia, obj.comune, obj.zona, obj.coords, this.orderAgent));
      this.professionistLoading = false;

    } catch (e) {
      this.professionistLoading = false;
      this.console.log(e);
      throw new Error(e);
    }
  }

  async getAgentData(): Promise<void> {
    this.agentArray = [];
    this.agentLoading = true;
    try {
      // const filter = JSON.stringify({
      //   limit: 12,
      //   order: ['average_stars DESC', 'number_reviews DESC'],
      //   include: 'agency',
      // });
      // this.agentArray = await lastValueFrom( this.agent.agentFind(filter));
      const obj = this.main.getInfoFromlastSearch();
      this.agentArray = await lastValueFrom(this.agent.agentSearchBest(8, obj.regione, obj.provincia, obj.comune, obj.zona, obj.coords, this.orderAgent));
      this.agentLoading = false;

    } catch (e) {
      this.agentLoading = false;
      this.console.log(e);
      throw new Error(e);
    }
  }

  async getNewsData(): Promise<void> {
    const filters = {
      order: 'created_at DESC',
      where: { status: 'available' },
      limit: 6,
      include: [{
        relation: 'zone',
        scope: {
          fields: {
            name: true,
            display_name: true,
          },
        },
      }, {
        relation: 'writtenBy',
        scope: {
          include: [{
            relation: 'agent',
            scope: { fields: { slug: true } },
          }, {
            relation: 'professionist',
            scope: { fields: { slug: true } },
          }],
        },
      }],
    };

    try {
      this.latestArticlesArray = await lastValueFrom(this.articleAPI.articleFind(JSON.stringify(filters)));
    } catch (e) {
      this.console.log(e);
      throw new Error(e);
    }
  }

  // go to visitingListing Page
  navigateToUserViditingListing(): void {
    if (this.isLogged) {
      this.router.navigate(['/utente-annunci'], {
        queryParams: { tab: 'annunci-visitati' },
      });
    }
    else {
      this.router.navigate(['/annunci-visitati']);
    }
  }

  async selectOrderAgent(value: any): Promise<void> {
    this.orderAgent = value;
    if (this.isAgentSelected) {
      await this.getAgentData();
    }
    else {
      await this.getProfessionistData();
      await this.main.getFavouriteProfessionists();
    }
  }

  closePopup(): void {
    this.modalIsOpen = false;
    this.formValue = 'accedi';
  }

  openPopup(): void {
    this.modalIsOpen = true;
  }

  async selectFilter(type: string): Promise<void> {
    if (type !== 'agent') {
      this.getProfessionistData();
      await this.main.getFavouriteProfessionists();
    }
    else {
      this.getAgentData();
    }
    this.isAgentSelected = type === 'agent';
  }
}
